import { Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import ChartPresion from './chartPresion';
import { UtilsTable } from '../../../../app/orussystem/utils/UtilTable';
import ChartDiastolica from './chartDiastolica';
import { GraficasStyles } from '../GraficasStyles';

const CardPresion = ({ rows, isLoad, paperStyle, lIcms }) => {
  const classes = GraficasStyles();

  return (
    <Paper>
      <Typography className={classes.title} color='primary'>Presión arterial</Typography>

      <Grid container spacing={2}>
        {/* Columna para ChartPresion */}
        <Grid item xs={12} lg={4}>
          <Paper className={paperStyle}>
            <ChartPresion data={lIcms} />
          </Paper>
        </Grid>
        {/* Columna para la tabla */}
        <Grid item xs={12} lg={4}>
          <Paper className={paperStyle}>
            <Table size="small">
              <TableHead>
                <TableRow alignItems="center">
                  <TableCell align="center">Fecha</TableCell>
                  <TableCell align="center">Diastólica</TableCell>
                  <TableCell align="center">Sistólica</TableCell>
                  <TableCell align="center">Frecuencia cardíaca</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoad ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">Cargando...</TableCell>
                  </TableRow>
                ) : (
                  rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{UtilsTable().validateRowsTable(UtilsDate().formatDDMMMYYYY(new Date(row.datecreate)))}</TableCell>
                      <TableCell align="center">{UtilsTable().validateRowsTable(row.diastolica)}</TableCell>
                      <TableCell align="center">{UtilsTable().validateRowsTable(row.sistolica)}</TableCell>
                      <TableCell align="center">{UtilsTable().validateRowsTable(row.frecuenciacardiaca)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
        {/* Columna para ChartDiastolica */}
        <Grid item xs={12} lg={4}>
          <Paper className={paperStyle}>
            <ChartDiastolica data={lIcms} />
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default CardPresion;
